import {
	ApplicationService,
	GamedayApiService,
	SeasonService
} from "@prestosports/prestostats-core/Services";
import GamedayApiClient from "../../services/gameday-api-client";
import {
	GET_CURRENT_SEASON,
	GET_CURRENT_SEASON_COMPLETE,
	GET_SEASONS,
	GET_SEASONS_COMPLETE,
	INIT_SEASON_DATA,
	INIT_SEASON_DATA_COMPLETE,
	RESET_CURRENT_SEASON,
	RESTORE_DEFAULT_GAME_CONFIGURATION,
	RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SAVE_DEFAULT_GAME_CONFIGURATION,
	SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SET_CURRENT_SEASON,
	SET_CURRENT_SEASON_COMPLETE,
	SET_RULE_SET_ID_COMPLETE,
	SET_SEASON_CONFIGURATION,
	SET_SEASON_CONFIGURATION_COMPLETE
} from "./constants";
import { clearEvents } from "../events/actions";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

const mapSeason = (season) => {
	return season?.toJSON();
};

export const setSeasonConfiguration = async (seasonId, dispatch) => {
	dispatch({
		type: SET_SEASON_CONFIGURATION
	});

	let payload = {
		defaultGameConfiguration: {},
		customFormData: {}
	};

	if (seasonId) {
		const { gameConfiguration, customFormData } =
			await SeasonService.getGameConfigurationOrDefault(seasonId);

		const currentSeason = mapSeason(await ApplicationService.getCurrentSeason());

		payload = {
			defaultGameConfiguration: gameConfiguration,
			customFormData,
			currentSeason
		};
	}

	dispatch({
		type: SET_SEASON_CONFIGURATION_COMPLETE,
		payload
	});
};

export const initSeasonData = async (seasonId, pagingOptions, dispatch) => {
	dispatch({
		type: INIT_SEASON_DATA
	});

	await ApplicationService.setCurrentSeason(seasonId);

	clearEvents(dispatch);
	await setSeasonConfiguration(seasonId, dispatch);

	dispatch({
		type: INIT_SEASON_DATA_COMPLETE
	});
};

export const saveDefaultGameConfiguration = async (
	seasonId,
	gameConfig,
	dispatch
) => {
	dispatch({
		type: SAVE_DEFAULT_GAME_CONFIGURATION
	});

	const { gameConfiguration: defaultGameConfiguration, customFormData } =
		await SeasonService.saveGameConfiguration(seasonId, gameConfig);

	dispatch({
		type: SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
		payload: { defaultGameConfiguration, customFormData }
	});
};

export const restoreDefaultGameConfiguration = async (seasonId, dispatch) => {
	dispatch({
		type: RESTORE_DEFAULT_GAME_CONFIGURATION
	});

	const { gameConfiguration: defaultGameConfiguration, customFormData } =
		await SeasonService.restoreDefaultGameConfiguration(seasonId);

	dispatch({
		type: RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
		payload: { defaultGameConfiguration, customFormData }
	});
};

export const getSeasons = async (sportCodes, dispatch) => {
	dispatch({
		type: GET_SEASONS
	});

	// try {
	const seasons = await GamedayApiService.getSeasons(sportCodes);
	dispatch({
		type: GET_SEASONS_COMPLETE,
		payload: { seasons: seasons && seasons.map(mapSeason) }
	});
	// } catch (e) {
	// 	// do nothing
	// 	console.error(e);
	// }
};

export const setCurrentSeasonById = async (seasonId, dispatch) => {
	dispatch({
		type: SET_CURRENT_SEASON
	});

	const currentSeason = await ApplicationService.setCurrentSeasonByExternalId(
		seasonId
	);

	await setSeasonConfiguration(currentSeason?.id, dispatch);

	dispatch({
		type: SET_CURRENT_SEASON_COMPLETE
	});
};

export const getCurrentSeason = async (dispatch) => {
	dispatch({
		type: GET_CURRENT_SEASON
	});

	const currentSeason = await ApplicationService.getCurrentSeason();

	dispatch({
		type: GET_CURRENT_SEASON_COMPLETE,
		payload: { currentSeason }
	});
};

export const resetCurrentSeason = (dispatch) => {
	dispatch({
		type: RESET_CURRENT_SEASON,
		payload: { currentSeason: null }
	});
};

export const setRuleSetId = async (season, ruleSetId, dispatch) => {
	const updatedSeason = await SeasonService.saveOrUpdateSeasonByRemoteId({
		...season,
		ruleSetId
	});
	const { gameConfiguration, customFormData } =
		await SeasonService.restoreDefaultGameConfiguration(season.id);

	dispatch({
		type: SET_RULE_SET_ID_COMPLETE,
		payload: {
			currentSeason: updatedSeason,
			defaultGameConfiguration: gameConfiguration,
			customFormData
		}
	});
};
